module.exports = __webpack_public_path__ + "img/skiing003.3cf6a1f1.jpg";